import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { useLenis } from './hooks/useLenis';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

// Pages
import Home from './pages/Home';
import GuidesPage from './pages/GuidesPage';
import GuideDetail from './pages/GuideDetail';
import GuidePremium from './pages/GuidePremium';
import GuideAccess from './pages/GuideAccess';
import GuidePreview from './pages/GuidePreview';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminNewsletter from './pages/AdminNewsletter';

// Styles
import './App.css';

const AppContent = () => {
  useLenis();
  const { language } = useLanguage();
  
  // Dynamic page title based on language
  useEffect(() => {
    document.title = language === 'it' 
      ? 'Huacaya - Guide di Viaggio Premium' 
      : 'Huacaya - Premium Travel Guides';
  }, [language]);
  
  return (
    <div className="App font-['Inter']">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/:id" element={<GuideDetail />} />
        <Route path="/guide/:id" element={<GuidePremium />} />
        <Route path="/guide-access/:token" element={<GuideAccess />} />
        <Route path="/preview/:guideId" element={<GuidePreview />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/admin/newsletter" element={<AdminNewsletter />} />
      </Routes>
      <Footer />
      <CookieConsent />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
